import { API2_HOST } from 'helpers/urlHelper';
import {
  baseGetWithoutParam,
} from 'services/base-services/baseService';


export const getGrnDetails = async (grnNo) => {
  return await baseGetWithoutParam(`${API2_HOST}/sls-wpo-grns/${grnNo}`);
};

export const getGrnImages = async (grnNo) => {
  return await baseGetWithoutParam(`${API2_HOST}/sls-wpo-grns/${grnNo}/images`);
};